document.addEventListener('DOMContentLoaded', () => {
  const modalsContainer = document.getElementById('pdp-modals');
  const allModals = modalsContainer ? modalsContainer.querySelectorAll('[id^="modal-"]') : [];
  const modalTriggers = document.querySelectorAll('[data-modal-trigger]');
  const closeButtons = document.querySelectorAll('.js-modal-close');

  const sizeRadios = document.querySelectorAll('input[name="modal_size"]');
  const hiddenVariantInput = document.getElementById('product-variant-id');
  const compareAtInput = document.getElementById('product-compare-at-cents');
  const addCartBtns = [document.getElementById('desktop-add-to-cart'), document.getElementById('mobile-add-to-cart')];

  const productForm = document.getElementById('product-form');
  let isSizeSelected = productForm ? productForm.getAttribute('data-has-selected-variant') === 'true' : false;
  let isVariantAvailable = productForm ? productForm.getAttribute('data-variant-available') !== 'false' : true;

  addCartBtns.forEach(btn => {
    if (btn && isVariantAvailable) {
      btn.disabled = false;
      btn.classList.remove('opacity-50', 'cursor-not-allowed');

      btn.addEventListener('click', (e) => {
        if (!isSizeSelected) {
          e.preventDefault();
          openModal('size-selector');
        }
      });
    }
  });

  let activeModalFocusTrap = null;

  function openModal(modalId) {

    allModals.forEach(m => {
      m.classList.remove('is-open');
    });

    const targetModal = document.getElementById('modal-' + modalId);
    if (targetModal) {
      if (modalsContainer) {
        modalsContainer.classList.remove('hidden');

        void modalsContainer.offsetWidth;
        modalsContainer.classList.remove('opacity-0', 'pointer-events-none');
      }
      targetModal.classList.add('is-open');

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      const header = document.getElementById('gz-header');
      if (header) {
        header.style.paddingRight = `${scrollbarWidth}px`;
      }

      document.body.style.overflow = 'hidden';

      if (window.FocusTrap) {
        activeModalFocusTrap = new FocusTrap(targetModal, {
          onEscape: closeAllModals
        });
        activeModalFocusTrap.activate();
      }
    }
  }

  function closeAllModals() {
    allModals.forEach(m => {
      m.classList.remove('is-open');
    });
    if (modalsContainer) {
      modalsContainer.classList.add('opacity-0', 'pointer-events-none');
      setTimeout(() => {
        modalsContainer.classList.add('hidden');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        const header = document.getElementById('gz-header');
        if (header) {
          header.style.paddingRight = '';
        }
        if (activeModalFocusTrap) {
          activeModalFocusTrap.deactivate();
          activeModalFocusTrap = null;
        }
      }, 300);
    }
  }

  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(trigger.dataset.modalTrigger);
    });
  });

  closeButtons.forEach(btn => {
    btn.addEventListener('click', closeAllModals);
  });

  if (modalsContainer) {
    modalsContainer.addEventListener('click', (e) => {
      if (e.target === modalsContainer) {
        closeAllModals();
      }
    });
  }

  sizeRadios.forEach(radio => {
    radio.addEventListener('click', (e) => {
      isSizeSelected = true;
      const variantId = e.target.value;

      if (hiddenVariantInput) {
        hiddenVariantInput.value = variantId;
      }

      if (compareAtInput) {
        compareAtInput.value = e.target.dataset.compareAtCents || '';
      }

      closeAllModals();

      setTimeout(() => {
        const submitBtn = document.getElementById('desktop-add-to-cart') || document.getElementById('mobile-add-to-cart');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.click();
        }

        // Reset selection so the modal opens again on next manual click
        isSizeSelected = false;
        sizeRadios.forEach(r => r.checked = false);
      }, 350);
    });
  });

  const mediaScrollContainer = document.querySelector('.js-media-scroll-container');
  const mediaSlides = document.querySelectorAll('.js-media-slide');
  const thumbDesktop = document.querySelector('.js-media-scroll-thumb-desktop');

  // The desktop gallery stacks images half a viewport wide. The browser's own lazy
  // threshold is too tight for the scroll speed here, so they land mid-scroll: promote
  // them to eager well before they come into view.
  if (mediaScrollContainer) {
    const pending = mediaScrollContainer.querySelectorAll('img[loading="lazy"]');

    if (pending.length) {
      const preloader = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          preloader.unobserve(entry.target);
          entry.target.loading = 'eager';
        });
      }, { rootMargin: '200% 0px' });

      pending.forEach(img => preloader.observe(img));
    }

    if (window.gzFadeInMedia) window.gzFadeInMedia(mediaScrollContainer);
  }

  if (mediaScrollContainer && mediaSlides.length > 1 && thumbDesktop) {
    let activeIndex = 0;

    const observer = new IntersectionObserver((entries) => {
      let highestRatio = 0;
      let mostVisibleSlide = null;

      // Find the slide taking up the most space in the viewport
      entries.forEach(entry => {
        if (entry.intersectionRatio > highestRatio) {
          highestRatio = entry.intersectionRatio;
          mostVisibleSlide = entry.target;
        }
      });

      if (mostVisibleSlide && highestRatio > 0.3) {
        const newIndex = Array.from(mediaSlides).indexOf(mostVisibleSlide);
        if (newIndex !== activeIndex) {
          activeIndex = newIndex;
          thumbDesktop.style.transform = `translateY(${activeIndex * 10}px)`;
        }
      }
    }, {
      root: null,
      rootMargin: '-20% 0px -20% 0px',
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]
    });

    mediaSlides.forEach(slide => observer.observe(slide));
  }

  const recommendationsContainer = document.querySelector('.js-product-recommendations');
  if (recommendationsContainer) {
    const url = recommendationsContainer.dataset.url;
    if (url) {
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const recommendations = doc.querySelector('.js-product-recommendations');
          if (recommendations && recommendations.innerHTML.trim() !== '') {
            recommendationsContainer.innerHTML = recommendations.innerHTML;
            if (window.gzInitSwipers) {
              window.gzInitSwipers();
            }
          }
        })
        .catch(err => console.error('Error loading related products:', err));
    }
  }

  const productSectionEl = document.querySelector('.js-product-fade-in');
  if (productSectionEl) {
    const currentHandle = productSectionEl.dataset.productHandle;
    if (currentHandle) {
      let recentlyViewed = [];
      try {
        recentlyViewed = JSON.parse(localStorage.getItem('gz_recently_viewed')) || [];
      } catch (e) {
        recentlyViewed = [];
      }

      recentlyViewed = recentlyViewed.filter(handle => handle !== currentHandle);

      if (recentlyViewed.length > 0) {
        const recentlyViewedSection = document.getElementById('recently-viewed-section');
        const container = document.querySelector('.js-recently-viewed-container');
        if (recentlyViewedSection && container) {
          const handlesToFetch = recentlyViewed.slice(0, 12);
          const queryParts = handlesToFetch.map(handle => `handle:${handle}`);
          const searchQuery = queryParts.join('+OR+');

          const root = window.Shopify?.routes?.root || '/';
          const fetchUrl = `${root}search?q=${searchQuery}&section_id=recently-viewed`;

          fetch(fetchUrl)
            .then(response => {
              if (!response.ok) {
                throw new Error(`Recently viewed section returned ${response.status}`);
              }
              return response.text();
            })
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const recentlyViewedContent = doc.querySelector('.js-recently-viewed-container');
              if (recentlyViewedContent && recentlyViewedContent.querySelector('.swiper-slide')) {
                container.innerHTML = recentlyViewedContent.innerHTML;
                recentlyViewedSection.classList.remove('hidden');
                if (window.gzInitSwipers) {
                  window.gzInitSwipers();
                }
              }
            })
            .catch(err => console.error('Error loading recently viewed products:', err));
        }
      }

      recentlyViewed.unshift(currentHandle);
      recentlyViewed = [...new Set(recentlyViewed)].slice(0, 6);
      localStorage.setItem('gz_recently_viewed', JSON.stringify(recentlyViewed));
    }
  }

  const mobileGallery = document.querySelector('.swiper-product-mobile');
  if (mobileGallery) {
    const setupProgressBar = () => {
      const swiper = mobileGallery.swiper;
      const progressBar = mobileGallery.querySelector('.js-mobile-gallery-progress-bar');
      if (swiper && progressBar) {
        const updateProgress = () => {
          const total = swiper.slides.length;
          progressBar.style.width = `${100 / total}%`;
          const index = swiper.activeIndex;
          progressBar.style.transform = `translateX(${index * 100}%)`;
        };
        updateProgress();
        swiper.on('slideChange', updateProgress);
      }
    };

    if (mobileGallery.classList.contains('swiper-initialized')) {
      setupProgressBar();
    } else {
      const observer = new MutationObserver((mutations) => {
        if (mobileGallery.classList.contains('swiper-initialized')) {
          observer.disconnect();
          setupProgressBar();
        }
      });
      observer.observe(mobileGallery, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // --- Lightbox Gallery ---
  const lightboxContainer = document.getElementById('lightbox-gallery');
  if (lightboxContainer) {
    const lightboxClose = lightboxContainer.querySelector('.js-lightbox-close');
    const mediaSlidesDesktop = document.querySelectorAll('.js-media-scroll-container .js-media-slide');
    let mainSwiper = null;
    let thumbsSwiper = null;

    const closeLightbox = () => {
      lightboxContainer.classList.add('opacity-0', 'pointer-events-none');
      setTimeout(() => {
        lightboxContainer.classList.add('hidden');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        const header = document.getElementById('gz-header');
        if (header) {
          header.style.paddingRight = '';
        }
      }, 300);
    };

    if (lightboxClose) {
      lightboxClose.addEventListener('click', closeLightbox);
    }

    lightboxContainer.addEventListener('click', (e) => {
      if (e.target === lightboxContainer || e.target.classList.contains('swiper-slide') || e.target.closest('.swiper-lightbox-main .swiper-slide')) {
        if (e.target === lightboxContainer || e.target.classList.contains('swiper-wrapper')) {
          closeLightbox();
        }
      }
    });

    const loadLightboxLazyImages = (swiperInstance) => {
      if (!swiperInstance) return;
      const loadImg = (idx) => {
        if (idx < 0 || idx >= swiperInstance.slides.length) return;
        const slide = swiperInstance.slides[idx];
        const img = slide.querySelector('.js-lightbox-lazy-image[data-src]');
        if (img) {
          img.onload = () => {
            img.classList.remove('opacity-0');
            img.classList.add('opacity-100');
          };
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        }
      };
      const active = swiperInstance.activeIndex;
      loadImg(active);
      loadImg(active - 1);
      loadImg(active + 1);
    };

    const initAndOpenLightbox = (index) => {
      lightboxContainer.classList.remove('hidden');
      void lightboxContainer.offsetWidth; // trigger reflow
      lightboxContainer.classList.remove('opacity-0', 'pointer-events-none');

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      const header = document.getElementById('gz-header');
      if (header) {
        header.style.paddingRight = `${scrollbarWidth}px`;
      }
      document.body.style.overflow = 'hidden';

      if (!mainSwiper && window.Swiper) {
        thumbsSwiper = new window.Swiper('.swiper-lightbox-thumbs', {
          spaceBetween: 8,
          slidesPerView: 'auto',
          freeMode: true,
          watchSlidesProgress: true,
          centerInsufficientSlides: true,
        });
        mainSwiper = new window.Swiper('.swiper-lightbox-main', {
          spaceBetween: 10,
          zoom: window.innerWidth < 1024 ? {
            maxRatio: 3,
            minRatio: 1
          } : false,
          navigation: {
            nextEl: '.swiper-button-next-lightbox',
            prevEl: '.swiper-button-prev-lightbox',
          },
          thumbs: {
            swiper: thumbsSwiper,
          },
          on: {
            slideChange: function () {
              const zoomedImages = document.querySelectorAll('.swiper-lightbox-main .is-zoomed');
              zoomedImages.forEach(img => {
                img.classList.remove('is-zoomed');
                img.style.transform = '';
                img.style.transformOrigin = '';
                img.style.cursor = 'zoom-in';
              });
              if (mainSwiper) mainSwiper.allowTouchMove = true;

              const progressBar = lightboxContainer.querySelector('.js-lightbox-progress-bar');
              if (progressBar && mainSwiper) {
                const total = mainSwiper.slides.length;
                progressBar.style.width = `${100 / total}%`;
                const index = mainSwiper.activeIndex;
                progressBar.style.transform = `translateX(${index * 100}%)`;
              }

              loadLightboxLazyImages(mainSwiper);
            }
          }
        });
      }

      if (mainSwiper) {
        mainSwiper.slideTo(index, 0);

        const progressBar = lightboxContainer.querySelector('.js-lightbox-progress-bar');
        if (progressBar) {
          const total = mainSwiper.slides.length;
          progressBar.style.width = `${100 / total}%`;
          progressBar.style.transform = `translateX(${index * 100}%)`;
        }

        loadLightboxLazyImages(mainSwiper);
      }
    };

    const ensureSwiperLoaded = (callback) => {
      if (window.Swiper) {
        callback();
        return;
      }
      const jsUrl = window.ThemeConfig?.swiperJsUrl;
      const cssUrl = window.ThemeConfig?.swiperCssUrl;

      if (!jsUrl) return;

      if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        document.head.appendChild(link);
      }

      let script = document.querySelector(`script[src="${jsUrl}"]`);
      if (script) {
        script.addEventListener('load', callback);
      } else {
        script = document.createElement('script');
        script.src = jsUrl;
        script.onload = callback;
        document.head.appendChild(script);
      }
    };

    // --- Custom Zoom for Lightbox ---
    const lightboxSlides = document.querySelectorAll('.swiper-lightbox-main .swiper-slide');
    lightboxSlides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;

      img.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

      slide.addEventListener('click', function (e) {
        if (window.innerWidth < 1024) return;
        if (e.target !== img && e.target !== slide) return;

        if (img.classList.contains('is-zoomed')) {
          img.classList.remove('is-zoomed');
          img.style.transform = '';
          img.style.transformOrigin = '';
          img.style.cursor = 'zoom-in';
          if (mainSwiper) mainSwiper.allowTouchMove = true;
        } else {
          img.classList.add('is-zoomed');
          const zoomLevel = 2400 / img.clientWidth;
          img.style.transform = `scale(${zoomLevel})`;
          img.style.cursor = 'zoom-out';
          if (mainSwiper) mainSwiper.allowTouchMove = false;

          const rect = slide.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });
    });

    lightboxContainer.addEventListener('mousemove', function (e) {
      if (window.innerWidth < 1024) return;
      const zoomedImg = lightboxContainer.querySelector('.swiper-lightbox-main .is-zoomed');
      if (zoomedImg) {
        const slide = zoomedImg.closest('.swiper-slide');
        const rect = slide.getBoundingClientRect();
        let x = ((e.clientX - rect.left) / rect.width) * 100;
        let y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        zoomedImg.style.transformOrigin = `${x}% ${y}%`;
      }
    });

    mediaSlidesDesktop.forEach((slide, index) => {
      slide.style.cursor = 'zoom-in';
      slide.addEventListener('click', () => {
        ensureSwiperLoaded(() => {
          initAndOpenLightbox(index);
        });
      });
    });

    const mobileSwiperContainer = document.querySelector('.swiper-product-mobile');
    if (mobileSwiperContainer) {
      const bindMobileLightbox = () => {
        const swiper = mobileSwiperContainer.swiper;
        if (swiper) {
          const openLightbox = () => {
            ensureSwiperLoaded(() => {
              initAndOpenLightbox(swiper.realIndex);
            });
          };
          swiper.on('tap', openLightbox);
          swiper.on('click', openLightbox);
        } else {
          setTimeout(bindMobileLightbox, 50);
        }
      };

      if (mobileSwiperContainer.classList.contains('swiper-initialized')) {
        bindMobileLightbox();
      } else {
        const observer = new MutationObserver(() => {
          if (mobileSwiperContainer.classList.contains('swiper-initialized')) {
            observer.disconnect();
            bindMobileLightbox();
          }
        });
        observer.observe(mobileSwiperContainer, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  // --- Mobile Sticky Add To Cart Footer Intersection ---
  const mobileStickyCart = document.getElementById('mobile-sticky-add-to-cart');
  const footerEl = document.querySelector('footer') || document.querySelector('[id*="footer"]');
  if (mobileStickyCart && footerEl) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          mobileStickyCart.classList.add('translate-y-full');
          mobileStickyCart.classList.remove('translate-y-0');
        } else {
          mobileStickyCart.classList.remove('translate-y-full');
          mobileStickyCart.classList.add('translate-y-0');
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    });
    footerObserver.observe(footerEl);
  }
});
